/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { NodeCompat } from '../compat/NodeCompat';

/**
 * Constructor.
 * @class
 * @author eric.wittmann@gmail.com
 */
export abstract class AbstractCommand implements ICommand {
    public constructor() {
    }

    /**
     * Returns true if the argument is either null or undefined.
     * @param {*} object
     * @return {boolean}
     */
    isNullOrUndefined(object : any) : boolean {
        return NodeCompat.isNullOrUndefined(object);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#type()
     * @return {string}
     */
    public type() : string {
        return /* getSimpleName */(c => c["__class"]?c["__class"].substring(c["__class"].lastIndexOf('.')+1):c["name"].substring(c["name"].lastIndexOf('.')+1))((<any>this.constructor));
    }

    public abstract undo(document?: any): any;
    public abstract execute(document?: any): any;}
AbstractCommand["__class"] = "io.apicurio.datamodels.cmd.AbstractCommand";
AbstractCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { ICommand } from './ICommand';

